import React from 'react';
import { Common } from 'ws-scripts/modules/common';
import { Button } from 'react-bootstrap';

import propDefs from '../proptypes';

class SeeAllHoursButton extends React.Component {
	constructor(props) {
		super(props);
		this.renderDelegate = this.renderDelegate.bind(this);
	}

	renderDelegate({ prefs, labels }) {
		if (!(prefs.showDepartmentsViewAllLink === 'true')) {
			return null;
		}

		const classNames = [prefs.showDepartmentsViewAllLinkButtonLayout];
		if (prefs.showDepartmentsViewAllLinkButtonInverse === 'true') {
			classNames.push('btn-inverse');
		}
		if (prefs.showDepartmentsViewAllLinkButtonSize) {
			classNames.push(
				`btn-${prefs.showDepartmentsViewAllLinkButtonSize}`
			);
		}

		return (
			<div className="text-center">
				<Button
					onClick={this.props.showModalAction}
					bsStyle={prefs.showDepartmentsViewAllLinkButtonStyle}
					className={classNames.join(' ')}
				>
					{labels.get('SEE_ALL_DEPARTMENT_HOURS')}
				</Button>
			</div>
		);
	}

	render() {
		return <Common render={this.renderDelegate} />;
	}
}

SeeAllHoursButton.propTypes = {
	showModalAction: propDefs.settings.getModalDisplay.isRequired
};

export default SeeAllHoursButton;



// WEBPACK FOOTER //
// ./src/components/SeeAllHoursButton.jsx